import { useContext } from "react";
import { Web3Context } from "@/store/Web3Provider";

const useWeb3 = () => {
  const {
    account,
    connect,
    contract,
    signer,
    contractAddress,
    hasMetamask,
    balanceIce,
    iceApproved,
    allowedIceAmount,
    DGMarketplace,
    userCollections,
    createUserCollection,
    userCollectionsAddresses,
    loadingSellMoralis,
    userCollectionsWallet,
    tokensInCollection,
    getAllUserNftFromWallet,
    modalBody,
    modalTitle,
    createNotification,
    closeNotification,
    openModal,
  } = useContext(Web3Context);

  return {
    account,
    connect,
    contract,
    signer,
    contractAddress,
    hasMetamask,
    balanceIce,
    iceApproved,
    allowedIceAmount,
    DGMarketplace,
    userCollections,
    createUserCollection,
    userCollectionsAddresses,
    loadingSellMoralis,
    userCollectionsWallet,
    tokensInCollection,
    getAllUserNftFromWallet,
    modalBody,
    modalTitle,
    createNotification,
    closeNotification,
    openModal,
  };
};
export default useWeb3;
